import React, { useState, useEffect } from 'react';
import './ContentWarningModal.css';

function ContentWarningModal() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Check if user has already seen the warning
    const hasSeenWarning = localStorage.getItem('wtf-wear-warning-accepted');
    if (!hasSeenWarning) {
      setIsOpen(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('wtf-wear-warning-accepted', 'true');
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2 style={{ color: '#ffffff' }}>CONTENT WARNING</h2>
        </div>
        <div className="modal-body">
          <p>
            Welcome to WTF Wear! Please be advised that some of the humor and content
            on this site may be immature, crude, or contain adult themes.
          </p>
          <p>
            By continuing, you acknowledge that you understand and accept this.
          </p>
        </div>
        <div className="modal-footer">
          <button className="modal-accept-button" onClick={handleAccept}>
            I Understand - Enter Site
          </button>
        </div>
      </div>
    </div>
  );
}

export default ContentWarningModal;
